import { Spinner } from "@chakra-ui/react";
import React from "react";

const LoadingFullscreen = () => {
  return (
    <div className="h-screen flex items-center justify-center py-3">
      <Spinner />
    </div>
  );
};

export default LoadingFullscreen;
